import { FiniteListWithAsyncLoaderAbstract, ListProps } from "shared/components/Components";
import { useMercuryContext } from "../context";

export const fetchProducts = async (context: any) => {
  const { data } = await context.gpClient.get(
    "/google-gp-v1/project/listFields/product"
  );
  return data.map((item: any) => ({
    title: item.label,
    value: item.value,
  }));
};

class ProductFilter extends FiniteListWithAsyncLoaderAbstract {
  fetch() {
    return fetchProducts(this.props.context);
  }
}

export default (props: ListProps) => {
  const context = useMercuryContext();
  return <ProductFilter context={context} {...props} />;
};
